module.exports = __webpack_public_path__ + "static/minsion_bn1@2x-e87cdf4c9c8b90b7480599188809a451.jpg";